<div class="flex justify-content-start align-items-center flex-wrap gap-2">
    <strong class="default-text"><i class="fa fa-file-invoice mr-2"></i>Fatture</strong>
    <p-divider layout="vertical" class="inline-block"></p-divider>
    <app-action-button label="Lista fatture" (click)="toToInvoices()"/>
    <p-divider layout="vertical" class="inline-block"></p-divider>
    <app-input label="Cerca per WHSID" labelWidth="auto"
               placeholder="Inserisci WHSID" actionButtonLabel="Conferma"
               [showLength]="false"
               [(model)]="whsid"
               (action)="searchByWhsid()"></app-input>
</div>
